// extracted by mini-css-extract-plugin
export default {"skeleton":"TextAreaComponent_skeleton__MjJKb"};